import React, { useEffect, useState } from 'react';

import { getRandomString } from '../../../utils';
import { CrossTagIcon, PlusTagIcon, TagItem, TagSelectorWrapper } from './style';

export type Tag = {
  name: string;
  tagLabel: string;
  active: boolean;
  custom?: boolean;
  notChange?: boolean;
};

type Props = {
  options: Tag[];
  onChange?: (options: string[]) => void;
  createMode?: boolean;
};

const TagSelector = ({ options, onChange, createMode }: Props): JSX.Element => {
  const [tagItems, setTagItems] = useState<Tag[]>(options);

  useEffect(() => {
    setTagItems(options);
  }, [options]);

  const addTagHandle = () => {
    const customFieldsNumber = tagItems.filter((item) =>
      item.name.includes('Custom field ')
    ).length;
    setTagItems((prev) => [
      ...prev,
      {
        name: `custom_field_${customFieldsNumber}`,
        tagLabel: `Custom field ${customFieldsNumber}`,
        active: true,
        custom: true
      }
    ]);
  };

  useEffect(() => {
    if (onChange) {
      const activeTags = tagItems.filter((item) => item.active).map((item) => item.name);

      onChange(activeTags);
    }
  }, [tagItems]);

  const tagHandle = (name: string, isCustom: boolean, notChange: boolean) => {
    if (notChange) {
      return;
    }
    if (isCustom) {
      setTagItems((prev) => prev.filter((tag) => tag.name !== name));
      return;
    }
    setTagItems((prev) =>
      prev.map((tag) => {
        if (tag.name === name) {
          return { ...tag, active: !tag.active };
        }
        return tag;
      })
    );
  };

  return (
    <TagSelectorWrapper>
      {tagItems.map((item) => (
        <TagItem
          onClick={() => {
            tagHandle(item.name, !!item.custom, !!item.notChange);
          }}
          active={item.active}
          key={getRandomString()}>
          {!item.notChange && item.active ? <CrossTagIcon size={16} /> : <PlusTagIcon size={16} />}
          {item.tagLabel}
        </TagItem>
      ))}
      {createMode && (
        <TagItem onClick={addTagHandle}>
          <PlusTagIcon size={16} />
          Custom field
        </TagItem>
      )}
    </TagSelectorWrapper>
  );
};

export default TagSelector;
